<template>
  <div>
    <div class="search-filters-header">
      <div class="header-title">
        Statistics Generator - Results
      </div>
      <div class="header-subtitle">
        Result of generated statistics
      </div>
    </div>
    <ul class="nav nav-tabs" style="margin-left: 28px" role="tablist">
      <li class="nav-item" :class="{active: activeTab === 'summary',show: activeTab === 'summary'}"
          @click="switchTab('summary')"
      >
        <h5 class="nav-link"
            :class="{active: activeTab === 'summary',show: activeTab === 'summary'}"
        >
          Summary <span v-if="parsedSummary['data'] && parsedSummary['data'].length"
                        class="badge badge-primary ml-1"></span>
        </h5>
      </li>
      <li v-if="showCharts" class="nav-item" :class="{active: activeTab === 'charts',show: activeTab === 'charts'}"
          @click="switchTab('charts')"
      >
        <h5 class="nav-link"
            :class="{active: activeTab === 'charts',show: activeTab === 'charts'}"
        >
          Charts <span v-if="parsedChartData && parsedChartData.length"
                       class="badge badge-primary ml-1">{{parsedChartData.length}}</span>
        </h5>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane" :class="{active: activeTab === 'summary',show: activeTab === 'summary'}">
        <Loader :show="loadingData" :fixed="false"/>
        <RDFSummary :data="parsedSummary" :download-file="downloadFile" />
      </div>
      <div class="tab-pane" :class="{active: activeTab === 'summary',show: activeTab === 'summary'}">
        <Loader :show="loadingData" :fixed="false"/>
        <RDFCorrelation :data="parsedCorrelationData" :download-file="downloadFile" />
      </div>
      <div class="tab-pane" :class="{active: activeTab === 'charts',show: activeTab === 'charts'}">
        <Loader :show="loadingData" :fixed="false"/>
        <RDFCharts :data="parsedChartData" :download-file="downloadFile" />
      </div>
    </div>
  </div>
</template>

<script>
import RDFCharts from '@/components/RDFForms/RDFCharts'
import RDFSummary from '@/components/RDFForms/RDFSummary'
import RDFCorrelation from '@/components/RDFForms/RDFCorrelation'
import Loader from '@/components/shared/Loader'

export default {
  name: 'RDFTabs',
  components: {
    RDFCharts,
    RDFSummary,
    RDFCorrelation,
    Loader
  },
  props: {
    loadingData: Boolean,
    rdfData: Object,
    downloadFile: Function,
    showCharts: Boolean
  },
  data () {
    return {
      activeTab: 'summary'
    }
  },
  computed: {
    parsedChartData () {
      return this.rdfData.charts || []
    },
    parsedSummary () {
      return {
        'headers': (this.rdfData && this.rdfData.summary) ? this.rdfData.summary.headers : [],
        'data': (this.rdfData && this.rdfData.summary) ? this.rdfData.summary.data : []
      }
    },
    parsedCorrelationData () {
      return {
        'data': (this.rdfData && this.rdfData.correlation) ? this.rdfData.correlation.data : []
      }
    }
  },
  methods: {
    switchTab (tabName) {
      this.activeTab = tabName
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import url('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');

.search-filters-header {
  height: 160px;
  width: 100%;
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid #231A44;
  border-left: 0;
  border-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 34px;
  padding-top: 13px;
  position: relative;

  .header-title {
    width: 500px;
    height: 56px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 45px;
    line-height: 30px;
    font-weight: 900;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: white;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header-subtitle {
    height: 30px;
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0;
    margin-bottom: 56px;
  }

  .filter-tabs-wrapper {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: -1px;
    right: 0;
    z-index: 3;
    width: 100%;
    padding-right: 80px;

    .filters-tab {
      max-width: 240px;
      width: 100%;
      height: 44px;
      color: $dusty-blue;
      border: 1px solid #25232C;
      background-color: $silver;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 20px;
      line-height: 25px;
      letter-spacing: 0;
      cursor: pointer;
      border-left: 0;

      &:first-of-type {
        border-left: 1px solid #25232C;
      }
    }

    .saved-searches-toggle {
      position: absolute;
      width: 80px;
      transition: right 0.35s ease-in-out;
      background-color: #3981FF;
      bottom: 0;
      border-left: 1px solid #25232C;
      border-right: 1px solid #25232C;
    }

    .selected {
      border-bottom: 0;
      background-color: $light-grey !important;
      font-weight: 900;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 80%;
        left: 10%; /*this centers it based on the above width*/
        border-bottom: 2px solid $dusty-blue;
      }
    }
  }
}

.tab-pane {
}

.nav-link {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  color: #A46743 !important;

  &:hover {
    border-bottom-color: $charcoal !important;
  }

  &.active {
    position: relative;
    color: $input-label !important;
    background-color: #fff !important;

    &:hover {
      border-bottom-color: transparent !important;
    }

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      width: 80%;
      left: 10%; /*this centers it based on the above width*/
      border-bottom: 2px solid $dusty-blue;
    }
  }
}

.tab-content {
  border: 1px solid $charcoal;
  border-left: 0;
  border-right: 0;
}

.badge {
  border-radius: 2px;
  background-color: $blueberry !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
}

</style>
